export const NOTIFICATIONS_NOT = 'У вас нет новых уведомлений.'